export default class ClearRecentCustomers {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.recentCustomers.set([]);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/recent_customers/clear_recent_customers.js